import { handleSDInterest } from "utils/clientAPIs/interest";
import { DetailButtonsContext } from "./Index";
import { useContext } from "react";
import { useMemo } from "react";
import { useState } from "react";
import axios from "axios";
import * as Sentry from "@sentry/nextjs";
import { useRouter } from "next/router";
import { useWatchlist } from "lib/analytics/react/hooks";
import { toLoginPage } from "utils/routing";

export const useDetailInterestClick = () => {
    const router = useRouter();
    const { add, remove } = useWatchlist();
    const {
        dispatch,
        state,
        setClickBlockToastVisible,
        alarmRegister,
        session,
        detailData,
        sessionUpdate,
        update,
    } = useContext(DetailButtonsContext);

    const isInterested = useMemo(() => {
        if (session && session.user) {
            return session.user.interest.includes(detailData?.ITEM_CD_DL);
        }
    }, [session, detailData]);

    const [interestToastVisible, setInterestToastVisible] = useState(false);
    const [interestErrorToastVisible, setInterestErrorToastVisible] =
        useState(false);

    const handleStarClick = async () => {
        if (state[1].isBlocked) {
            setClickBlockToastVisible(true);
            return;
        }

        dispatch({ type: "click", button: 1 });

        if (state[1].clickCount >= 9) {
            dispatch({ type: "block", button: 1 });
            setTimeout(() => dispatch({ type: "unblock", button: 1 }), 30000);
        }
        if (state[1].totalClicks >= 29) {
            dispatch({ type: "block", button: 1 });
            setTimeout(() => dispatch({ type: "unblock", button: 1 }), 30000);
        }

        try {
            const action = isInterested ? remove : add;
            action.start({
                ticker: detailData.ITEM_CD_DL,
                market: detailData.MARKET_CD_DL,
                cat: detailData.CAT_CD_DL,
                from_list_id: "stock_detail_header",
            });
            if (!session || !session.user) {
                toLoginPage(router, "watchlist");
                // router.push(`/login?from=${router.asPath}`);
                return;
            }
            try {
                const res = await handleSDInterest({
                    session,
                    update,
                    detailData,
                    router,
                    isInterested,
                    setInterestToastVisible,
                    setInterestErrorToastVisible,
                });

                if (res === false) return;
                action.success();
            } catch (error) {
                action.fail(
                    "backend_" + (error as any)?.response?.status?.toString() || "500"
                );
            }

            if (!isInterested) {
                // 관심 자산 등록 시 알림 등록

                // 전체 알림 토글 OFF 일때는 알림 등록하지 않음
                await alarmRegister({
                    from: "star",
                });
                await sessionUpdate();
            } else {
                // 관심 자산 삭제 시 알림 또한 삭제
                try {
                    await axios.delete(
                        session?.user?.email
                            ? `/api/auth/alarm?email=${session.user.email}&ITEM_CD_DL=${detailData.ITEM_CD_DL}`
                            : ""
                    );
                    await sessionUpdate();

                    // update();
                } catch (e: any) {
                    console.log("error:", e);
                }
            }
        } catch (e: any) {
            // console.log("error:", e);
            Sentry.captureException("Interest Error:" + e);
            return;
        }
    };
    return {
        handleStarClick,
        interestToastVisible,
        setInterestToastVisible,
        interestErrorToastVisible,
        isInterested,
    };
}

export const useDetailAlarmClick = () => {
    const router = useRouter();

    const {
        dispatch,
        state,
        setClickBlockToastVisible,
        alarmRegister,
        session,
        detailData,
        sessionUpdate,
        update,
    } = useContext(DetailButtonsContext);

    const [alarmToastVisible, setAlarmToastVisible] = useState(false);
    const [alarmSuccessToastVisible, setAlarmSuccessToastVisible] =
        useState<any>();

    const isAlarmRegistered = useMemo(() => {
        if (session && session.user) {
            return session.user.alarm.includes(detailData?.ITEM_CD_DL);
        }
    }, [session, detailData]);

    const handleAlarmClick = async (success?: () => void, fail?: (reason?: string) => void) => {
        if (!session || !session.user) {
            router.push(`/login?from=${router.asPath}`);
            return;
        }
        if (state[2].isBlocked) {
            setClickBlockToastVisible(true);
            return;
        }

        dispatch({ type: "click", button: 2 });

        if (state[2].clickCount >= 9) {
            dispatch({ type: "block", button: 2 });
            setTimeout(() => dispatch({ type: "unblock", button: 2 }), 30000);
        }
        if (state[1].totalClicks >= 29) {
            dispatch({ type: "block", button: 2 });
            setTimeout(() => dispatch({ type: "unblock", button: 2 }), 30000);
        }

        //알림 삭제
        if (isAlarmRegistered) {
            try {
                await axios.delete(
                    session?.user?.email
                        ? `/api/auth/alarm?email=${session.user.email}&ITEM_CD_DL=${detailData.ITEM_CD_DL}`
                        : ""
                );
                update();
                // await sessionUpdate();
            } catch (e: any) {
                console.log(e);
            }
        } else {
            // 알림 등록
            try {
                await alarmRegister({
                    from: "alarm",
                    setAlarmSuccessToastVisible: setAlarmSuccessToastVisible,
                    fail: fail,
                    success: success,
                });
                await sessionUpdate();
                // setAlarmToastVisible(true);
            } catch (e: any) {
                Sentry.captureException(e);
                fail && fail();
                console.log(e);
            }
        }
    };
    return {
        handleAlarmClick,
        alarmToastVisible,
        setAlarmSuccessToastVisible,
        setAlarmToastVisible,
        alarmSuccessToastVisible,
        isAlarmRegistered,
    };
}